<app-loader></app-loader>
<router-outlet></router-outlet>

@if (!loggedIn) {
  <div>
    <div class="terms-header">
      <a [routerLink]="['/']">
        <img src="../../assets/icons/myBGCA.png" class="logoNavbar" />
      </a>
      <!-- <h2 class="d-flex justify-content-center ">myBGCA</h2> -->
    </div>
    <div class="app-loading">
      <div class="logo">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
      </div>
      <!-- <p class="initial-validation">Loading... Please wait...</p> -->
    </div>
    <div class="registration-footer">
      <a [routerLink]="['/']">
        <img src="../../assets/icons/myBGCA.png" class="logoNavbar" />
      </a>
      <div class="footer-right-section">
        <span>Copyright © 2021 Boys & Girls Clubs of America. All rights reserved.
        </span>
        <ul>
          <li>
            <a [routerLink]="['/termsofuse']"> Terms of Use</a>
          </li>
          <li>
            <a [routerLink]="['/legalpolicy']"> Legal Notice & Privacy Policy</a>
          </li>
          <li>
            <a [routerLink]="['/faq']"> Help Guides</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
}
